<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-100 p-4 md:p-0">
    <div class="bg-white shadow-lg rounded-lg flex flex-col md:flex-row w-full max-w-[700px] md:h-[450px] overflow-hidden relative">

      <!-- Left Side -->
      <div class="w-full md:w-1/2 relative flex items-center justify-center bg-gray-50">
        <img src="../images/logo/Ecole Ronsard.png"
             class="absolute inset-0 w-full h-full object-contain opacity-50 pointer-events-none">
      </div>

      <!-- Right Side -->
      <div class="w-full md:w-1/2 p-6 md:p-8 flex flex-col justify-center relative">

        <!-- Spinner -->
        <div v-if="showSpinner"
             class="absolute inset-0 bg-white/80 backdrop-blur-sm flex items-center justify-center z-50">
          <div class="flex flex-col items-center gap-4">
            <div class="relative">
              <div class="w-14 h-14 border-4 border-primary/30 rounded-full"></div>
              <div class="w-14 h-14 border-4 border-t-secondary border-r-secondary border-b-transparent border-l-transparent rounded-full absolute inset-0 animate-spin"></div>
            </div>
            <div class="text-primary font-medium">Logging in...</div>
          </div>
        </div>

        <h2 class="text-xl font-bold text-center text-primary mb-6">Login</h2>

        <form @submit.prevent="login" class="space-y-4">
          <div>
            <label class="block font-medium text-primary mb-1">Email</label>
            <input type="email"
                   v-model="email"
                   class="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:border-secondary">
          </div>

          <div>
            <label class="block font-medium text-primary mb-1">Password</label>
            <input type="password"
                   v-model="password"
                   class="w-full border border-gray-300 rounded px-4 py-2 focus:outline-none focus:border-secondary">
          </div>

          <button type="submit"
                  :disabled="showSpinner"
                  class="w-full bg-secondary text-white py-2.5 rounded">
            Login
          </button>
        </form>

        <p v-if="error" class="text-red-500 text-sm mt-4 text-center">
          {{ error }}
        </p>

      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import api from "@/services/api"
import { useRouter } from 'vue-router'

const router = useRouter()

const email = ref('')
const password = ref('')
const error = ref('')
const showSpinner = ref(false)


const login = async () => {
  error.value = ''
  showSpinner.value = true

try {
  const res = await api.post('Login.php', {
    email: email.value,
    password: password.value
  });

  if (res.data.success) {
    const user = res.data.user;
    console.log('Logged in:', user);

    // Save user to localStorage
    localStorage.setItem('user', JSON.stringify(user));

    // Redirect based on user_type
    if (user.role === 'HR' || user.role === 'Human Resources') {
      router.push('/hrdashboard');
    } else if (user.role === 'Teacher') {
      router.push('/academics-dashboard');
    } else if (user.role == 'Academics') {
      
      router.push('/academics-dashboard');
    }
    else if (user.role ==='IT')
    {
      router.push('/it-dashboard')
    }
    else if (user.role == 'Com')
    {
      router.push('/com-dashboard')
    }
    else if(user.role == 'Admin'){
      router.push('/main-page');
    }

  } else {
    error.value = res.data.message;
  }

} catch (err) {
  console.error(err);
  error.value = 'Server error';
} finally {
  showSpinner.value = false;
}
}
</script>